import { connect } from 'react-redux'
import './ProjectCover.scss'
import { useIntl } from 'react-intl'
import FileUpload from '@/app/components/UI/FileUpload/FileUpload'
import { ProjectsService, UploadFileType } from '@/app/services/ProjectsService'
import { layoutActions } from '@Techedge/digitalportal-shared'
import { newActivityCreationError } from '@/app/redux/actions/activity-creation'

const ProjectCover = (props) => {
    const componentClass = 'smart-new-activity-main-info-project-cover'
    const { form, onSave, setLoading, newActivityCreationError } = props
    const intl = useIntl()

    const handlerSave = (form) => {
        const reader = new FileReader()
        reader.onload = function (evt) {
            setLoading(true)
            ProjectsService.UploadFile(
                evt.target.result,
                UploadFileType.PHOTO,
                form.cover.value.file.name,
                form.cover.value.file.type
            )
                .then((res) => {
                    onSave({
                        ...form,
                        cover: { ...form.cover, value: { ...form.cover.value, id: res.data.id } },
                    })
                    setLoading(false)
                })
                .catch((e) => {
                    setLoading(false)
                    newActivityCreationError(e.response?.data?.message || e.message)
                })
        }
        reader.readAsDataURL(form.cover.value.file)
    }

    const onFormatError = () => {
        newActivityCreationError(
            intl.formatMessage({
                id: 'modals.new.activity.section.main.info.project.cover.format.error',
                defaultMessage:
                    'Selected image format cannot be processed, please use images with one of the following formats: .apng,.avif,.gif,.jpg,.jpeg,.jfif,.pjpeg,.pjp,.png,.svg,.webp, .bmp,.ico,.cur,.tif,.tiff',
            })
        )
    }
    const onSizeError = () => {
        newActivityCreationError(
            intl.formatMessage({
                id: 'modals.new.activity.section.main.info.project.cover.size.error',
                defaultMessage:
                    'Selected image exceeds the size limit of 20MB',
            })
        )
    }

    return (
        <div className={componentClass}>
            <div className={`${componentClass}__title-container`}>
                <span className="mandatory">*</span>
                <span className={`${componentClass}__title text-bold`}>
                    {intl.formatMessage({
                        id: 'modals.new.activity.section.main.info.project.cover',
                        defaultMessage: 'Project cover',
                    })}
                </span>
            </div>
            <FileUpload
                form={form}
                onSave={handlerSave}
                disabled={form.cover.disabled}
                inputProps={{
                    accept: `
                        .apng,.avif,.gif,.jpg,.jpeg,.jfif,.pjpeg,.pjp,.png,.svg,.webp,.bmp,.ico,.cur,.tif,.tiff
                        .APNG,.AVIF,.GIF,.JPG,.JPEG,.JFIF,.PJPEG,.PJP,.PNG,.SVG,.WEBP,.BMP,.ICO,.CUR,.TIF,.TIFF
                    `,
                }}
                onFormatError={onFormatError}
                onSizeError={onSizeError}
            />
        </div>
    )
}

const mapStateToProps = (state: any) => ({})

const mapDispatchToProps = (dispatch: any) => ({
    setLoading: (loading) => dispatch(layoutActions.setModals({ props: { loading } })),
    newActivityCreationError: (err) => dispatch(newActivityCreationError(err)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ProjectCover)
